export default __webpack_public_path__ + "img/mplus-client.313ddaa2.svg";